import { useMemo, useState } from 'react';
import { ButtonMenu } from '../ButtonMenu';
// import { StatsDocuments } from '../StatsDocuments';
import { StatsMain } from '../StatsMain';
import { StatsSkills } from '../StatsSkills';
import { StatsMenu, statsMenuIcons, statsMenuNames } from './Stats.model';
import { StyledContainer, StyledMenuContainer } from './Stats.styled';

const tabs = {
	[StatsMenu.Skills]: StatsSkills,
	[StatsMenu.Main]: StatsMain,
	// [StatsMenu.Documents]: StatsDocuments,
};

const Stats = () => {
	const [activeMenuItem, setActiveMenuItem] = useState(StatsMenu.Skills);

	const ActiveTab = useMemo(() => tabs[activeMenuItem], [activeMenuItem]);

	return (
		<StyledContainer>
			<StyledMenuContainer>
				<ButtonMenu
					buttons={Object.values(StatsMenu).map((item) => ({
						label: statsMenuNames[item],
						icon: statsMenuIcons[item],
					}))}
					activeIndex={Object.values(StatsMenu).indexOf(activeMenuItem)}
					setActiveIndex={(index) =>
						setActiveMenuItem(Object.values(StatsMenu)[index])
					}
				/>
			</StyledMenuContainer>
			<ActiveTab />
		</StyledContainer>
	);
};

export { Stats };
